const editorOptions = [
  "bold",
  "underline",
  {
    name: "italic",
    title: "Italicize",
    icon: `<i class="mdi mdi-format-italic pt-2"></i>`,
    result: () => window.pell.exec("italic"),
  },
  {
    name: "clear",
    title: "Clear format",
    icon: `<i class="mdi mdi-broom"></i>`,
    result: () => document.execCommand("removeFormat"),
  },
  {
    name: "outdent",
    title: "Outdent",
    icon: `<i class="mdi mdi-format-indent-decrease"></i>`,
    result: () => window.pell.exec("outdent"),
  },
  {
    name: "indent",
    title: "Indent",
    icon: `<i class="mdi mdi-format-indent-increase"></i>`,
    result: () => window.pell.exec("indent"),
  },
  {
    name: "superscript",
    title: "Superscript",
    icon: `<i class="mdi mdi-format-superscript"></i>`,
    result: () => document.execCommand("superscript"),
  },
  {
    name: "subscript",
    title: "Subscript",
    icon: `<i class="mdi mdi-format-subscript"></i>`,
    result: () => document.execCommand("subscript"),
  },
  {
    name: "orderedList",
    title: "Insert Ordered List",
    icon: `<i class="mdi mdi-format-list-bulleted"></i>`,
    result: () => window.pell.exec("insertUnorderedList"),
  },
  {
    name: "orderedList",
    title: "Insert Unordered List",
    icon: `<i class="mdi mdi-format-list-numbered"></i>`,
    result: () => window.pell.exec("insertOrderedList"),
  },
];

export { editorOptions };
